







































































































































































































































































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { VFields } from "@/models/v-fields";
import {
  UserModel,
  UserResetPasswordViewModel,
  UserStoreViewModel,
  AdminPermissionViewModel,
  TwoFaPermissionViewModel,
} from "@/models/admin/users";
import { VHeaders, PaginationModel, VAction } from "@/models/pagedlistmodel";
import { Utils } from "@/helper/utils";
import { AuthorizationHelper as _authorization } from "@/helper/authorization.helper";
import { Base } from "@/components/common/base";
import { IDialogOption } from "@/models/dialog";
import { FaxLineJsonDataViewModel, UpdateUser, Users } from "@/Alynk.dtos";
import { getStoreHeaders } from "@/views/admin/user/user";
import { userService, roleService } from "@/shared";
import VueUploadComponent from "vue-upload-component";
import { FileSize, RoleType } from "@/helper/enum";
import { FileUploadDataViewModel } from "@/Alynk.dtos";
import { FileHelper as _file, FileHelper } from "@/helper/file.helper";
import { IFileUploaderOption } from "@/models/fileUploader";

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    AppDialog: () => import("@/components/common/app.dialog.vue"),
    FileUpload: () => import('@/components/common//app.fileupload.v2.vue'),
    // FileUpload: VueUploadComponent,
  },
})
export default class UserSavePage extends Base {
  public storeHeaders: VHeaders[] = getStoreHeaders(this);
  public user: UserModel = {
    userStores: [],
  };
  public AdminRole: boolean = false;
  public SuperAdminRole: boolean = false;
  public drawer: boolean = false;
  public passwordForm: any = {};
  public passwordField: Array<VFields<any>> = [];
  public adminPermissionFields: Array<VFields<any>> = [];
  public twoFaPermissionFields: Array<VFields<any>> = [];

  public changePasswordModel: UserResetPasswordViewModel = {};
  public adminPermissionModel: AdminPermissionViewModel = {};
  public twoFaPermissionModel: TwoFaPermissionViewModel = {};
  public showTwoFa: boolean = false;

  public userStores: UserStoreViewModel[] = [];
  public routeRoles: string[];
  public role: string[];
  public adminPermissionDispay: boolean = false;
  public requestProgress: boolean = false;

  public currentMobileRoles: string[] = [];
  public selectedMobileRoles: string[] = [];
  public Mobileroles: string[] = [];

  public userId: string = "";
  public storeId: number = 0;
  public uId: number;
  public backToListStoreId: number = 0;
  public pagination = new PaginationModel("storeName", true, 5);
  public loading: boolean = false;
  public storeLoading: boolean = false;
  public tenantRole: boolean;
  public enterpriseRole: boolean;
  public buttons: any[] = [];
  public userToggle: any = {
    basicInfo: false,
    password: false,
    stores: false,
    adminPermission: false,
  };
  public storeIdToDelete: number;
  public showPassword: boolean = false;
  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t("dialogSettings.title") as string,
    model: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: this.$parent.$t("dialogSettings.btntxtAgree") as string,
    },
    loading: false,
    onAction: (): void => {
      this.deleteStore();
    },
  };
  public tenantId: number = 0;
  public enterpriseId: number = 0;

  public storeActions: any[] = [];

  public workDayModel: any = {
    faceId: "",
    employeeId: "",
    positionId: "",
  };
  public btnloading: boolean = false;
  public files: any = [];
  public attachmentFiles: FileUploadDataViewModel[] = [];
  public dragging: boolean = false;
  public dragclass: string = "";
  public selectedFiles: any = [];


  public fileUploderRef: string = "userProfile";
  public fileDialog: IFileUploaderOption = {
    ref: this.fileUploderRef,
    inputFiles: this.files,
    multiple: false,
    drop: true,
    extensions: ['.jpg','.jpeg','.png']
  };
  public syncAttachmentFiles(inputFilesToSync: any[], outputFilesToSync: FileUploadDataViewModel[]) {
    this.files = inputFilesToSync;
    this.attachmentFiles = outputFilesToSync;
  }


  public actions: any[] = [];
  public setStoreAction(): void {
    this.storeActions = [
      {
        type: "link",
        icon: "fas fa-edit",
        title: this.$t(
          "users.UserStoreGridHeaders.gridAction.updateStore"
        ) as string,
        color: "primary",
        visible: (model) => true,
        action: (model: any) => {
          if (this.storeId) {
            return {
              name: "admin.store.users.stores.edit",
              params: {
                storeId: this.storeId.toString(),
                id: this.userId,
                innerStoreId: model.storeId,
              },
            };
          } else {
            return {
              name: "admin.users.stores.edit",
              params: {
                id: this.userId,
                innerStoreId: model.storeId,
              },
            };
          }
        },
      },
      {
        type: "button",
        icon: "fas fa-trash-alt",
        title: this.$t(
          "users.UserStoreGridHeaders.gridAction.deleteStore"
        ) as string,
        color: "error",
        visible: (model: any) => true,
        action: (model: any) => {
          this.deleteWarning(model.storeId);
        },
      },
    ];
  }

  public setActions() {
    this.actions = [
      {
        type: "link",
        icon: "fas fa-edit",
        title: "Edit",
        action: (model: UserStoreViewModel, storeId: string) => {
          return {
            name: "admin.users.stores.edit",
            params: {
              id: model.userId,
              innerStoreId: model.storeId,
            },
          };
        },
      },
    ];
  }

  public hindetab() {
    if (this.drawer) {
      this.drawer = false;
    } else {
      this.drawer = true;
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }
  public callMethod(methodName): void {
    if (methodName === "backToUsers") {
      this.$router.push({ name: "admin.users" });
    } else if (methodName === "backToUsersWithParam") {
      this.$router.push({
        name: "admin.store.users",
        params: { storeId: this.backToListStoreId.toString() },
      });
    } else if (methodName === "editBasicDetails") {
      this.$router.push({ name: "admin.users.edit.info" });
    } else if (methodName === "addBasicDetails") {
      this.$router.push({ name: "admin.users.info" });
    } else if (methodName === "changePassword") {
      if (!this.passwordForm.$valid) {
        this.showAlert(false, "Form is invalid!");
        this.resetMethodName(methodName);
        return;
      }
      this.changePassword();
    } else if (methodName === "adminPermission") {
      this.adminPermission();
    } else if (methodName === "enableTwoFa") {
      this.enableTwoFa();
    } else if (methodName === "resetToken") {
      this.resetToken();
    } else if (methodName === "addUsersStoresWithStoreId") {
      this.$router.push({
        name: "admin.store.users.stores.add",
        params: { storeId: this.storeId.toString(), id: this.userId },
      });
    } else if (methodName === "addUsersStoresWithUserId") {
      this.$router.push({
        name: "admin.users.stores.add",
        params: { id: this.userId },
      });
    }

    this.resetMethodName(methodName);
  }

  public resetMethodName(methodName): void {
    if (methodName !== "") {
      this.$emit("resetMethodName", methodName);
    }
  }
  public addBasicDetailsButtons(): void {
    const buttons = [];
    this.updateToolBar(buttons);
  }
  public addPasswordButtons(): void {
    const buttons = [];
    this.updateToolBar(buttons);
  }
  public addAdminPermissionButtons(): void {
    const buttons = [];
    this.updateToolBar(buttons);
  }
  public add2FaPermissionButtons(): void {
    const buttons = [];
    this.updateToolBar(buttons);
  }
  public addUserStoresButtons(): void {
    const buttons = [];
    if (this.userId) {
      // empty block
    }
    this.updateToolBar(buttons);
  }

  public panel: any = [0];
  public userImageLoading: boolean = false;
  public userImagesList: any = [];
  public userFullImageUri: string = "";

  public showUserImageDetails: IDialogOption = {
    width: 500,
    title: this.$parent.$t(
      "sendMessage.roAttachmentDetailDialog.title"
    ) as string,
    model: false,
    loading: false,
    onClose: (): void => {
      this.userFullImageUri = "";
    },
  };

  public userWorkDay(): void {
    const buttons = [];
    this.updateToolBar(buttons);
  }
  public async submitRoles(): Promise<void> {
    try{

      this.btnloading = true;
      var model: UserModel = {
       email: this.user.email,
       mobileRoles: this.selectedMobileRoles
      };
      await userService.updateUserAsync(model);
      this.showAlert(true,"Roles Updated");
      this.currentMobileRoles = this.selectedMobileRoles;
    }
    finally{
      this.btnloading = false;
    }
  }
 
  public updateToolBar(buttons): void {
    this.buttons = [];
    if (this.backToListStoreId > 0) {
      this.buttons.push({
        id: "0",
        type: "button",
        title: this.$parent.$t("users.btnTitleBackToUser"),
        disabled: false,
        visible: true,
        class: "btn",
        label: this.$parent.$t("users.btnBack"),
        click: "backToUsersWithParam",
        icon: "fas fa-arrow-left",
      });
    } else {
      this.buttons.push({
        id: "0",
        type: "button",
        title: this.$parent.$t("users.btnTitleBackToUser"),
        disabled: false,
        visible: true,
        class: "btn",
        label: this.$parent.$t("users.btnBack"),
        click: "backToUsers",
        icon: "fas fa-arrow-left",
      });
    }
    if (buttons) {
      this.buttons = this.buttons.concat(buttons);
    }

    this.$emit("updateToolBar", this.buttons);
  }

  public async mounted() {
    // activating tab
    this.$root.$emit("sidebar.layout.vue", "users");

    var role = [
      RoleType.SuperAdmin.toString(),
      RoleType.TenantAdmin.toString(),
      RoleType.EnterpriseAdmin.toString(),
      RoleType.StoreAdmin.toString(),
    ];
    var isRoleAllowed = this.userSession.roles.filter((x) => role.includes(x));
    this.SuperAdminRole = isRoleAllowed.includes("SuperAdmin");
    this.AdminRole = isRoleAllowed.some((item) => role.includes(item));

    this.drawer = true;
    setInterval(() => {
      if (screen.width > 599) {
        this.drawer = true;
      }
    }, 2000);
    if (this.$route.params.id) {
      this.userId = this.$route.params.id;
      this.changePasswordModel.id = this.userId;
      this.adminPermissionModel.id = this.userId;
      this.twoFaPermissionModel.id = this.userId;
      this.setFields();
      this.GetUserDetailsByUserId();
      this.checkUserRole();
      this.setStoreAction();
      this.checkTwoFaAuthorization();
      this.getUserProfileImageInfo();
    }
    await this.GetAllMobileRoles();

    // Toolbar
    this.addBasicDetailsButtons();
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }
  public setFields(): void {
    this.passwordField = [
      {
        key: "password",
        type: "v-alynk-text-field",
        required: true,
        templateOptions: {
          counter: 500,
          label: this.$t("users.passwordTab.lblNewPassword") as string,
          type: this.showPassword ? "text" : "password",
          appendIcon: this.showPassword ? "mdi-eye" : "mdi-eye-off",
          required: true,
          disabled: false,
          hint: Utils.PasswordHint,
          events: {
            onClick: (showPassword) => {
              this.SetPasswordToggle();
            },
          },
          rules: [
            (v) => this.required("New Password", v),
            (v) => this.password(v),
          ],
        },
      },
      {
        key: "isTemp",
        type: "v-alynk-switch",
        required: false,
        templateOptions: {
          counter: 500,
          label: this.$t("users.passwordTab.lblIsTemp") as string,
          validations: "",
          required: true,
          disabled: false,
        },
      },
    ];
    this.adminPermissionFields = [
      {
        key: "tenantAdmin",
        type: "v-alynk-switch",
        required: false,
        templateOptions: {
          counter: 500,
          label: this.$t("users.adminPermissionTab.tenantAdmin") as string,
          validations: "",
          required: true,
          disabled: false,
          display: true,
          loading: false,
        },
      },
      {
        key: "enterpriseAdmin",
        type: "v-alynk-switch",
        required: false,
        templateOptions: {
          counter: 500,
          label: this.$t("users.adminPermissionTab.enterpriseAdmin") as string,
          validations: "",
          required: true,
          disabled: false,
          display: true,
          loading: false,
        },
      },
    ];

    this.twoFaPermissionFields = [
      {
        key: "isTwoFaEnabled",
        type: "v-alynk-switch",
        required: false,
        templateOptions: {
          counter: 500,
          label: this.$t("users.adminPermissionTab.enableTwoFA") as string,
          validations: "",
          required: true,
          disabled: false,
          display: true,
          loading: false,
        },
      },
    ];
  }

  public validatePassword(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  public async changePassword(): Promise<void> {
    if (this.validatePassword().validate()) {
      try {
        this.requestProgress = true;
        this.$emit("update:progress", this.requestProgress);
        await userService.changePasswordAsync(this.changePasswordModel);
        this.showAlert(true, this.$t("users.alertUserPasswordChanged"));
        this.changePasswordModel.password = "";
      } finally {
        this.requestProgress = false;
        this.$emit("update:progress", this.requestProgress);
      }
    }
  }

  public checkTwoFaAuthorization() {
    if (this.isAuthorizedToAccess(["SuperAdmin", "T-Admin", "E-Admin"])) {
      this.showTwoFa = true;
    } else {
      this.showTwoFa = false;
    }
  }

  public checkUserRole() {
    if (this.isAuthorizedToAccess(["SuperAdmin"])) {
      this.adminPermissionFields.find(
        (item) => item.key === "tenantAdmin"
      ).templateOptions.display = true;
      this.adminPermissionFields.find(
        (item) => item.key === "enterpriseAdmin"
      ).templateOptions.display = true;
      this.adminPermissionDispay = true;
    } else if (this.isAuthorizedToAccess(["T-Admin"])) {
      this.adminPermissionFields.find(
        (item) => item.key === "tenantAdmin"
      ).templateOptions.display = true;
      this.adminPermissionFields.find(
        (item) => item.key === "enterpriseAdmin"
      ).templateOptions.display = true;
      this.adminPermissionDispay = true;
    } else {
      this.adminPermissionFields.find(
        (item) => item.key === "tenantAdmin"
      ).templateOptions.display = false;
      this.adminPermissionFields.find(
        (item) => item.key === "enterpriseAdmin"
      ).templateOptions.display = false;
      this.adminPermissionDispay = false;
    }
  }

  public async adminPermission(): Promise<void> {
    try {
      this.requestProgress = true;
      this.$emit("update:progress", this.requestProgress);
      await userService.adminPremissionAsync(this.adminPermissionModel);
      this.showAlert(true, this.$t("users.alertUserPermissionUpdated"));
    } finally {
      this.requestProgress = false;
      this.$emit("update:progress", this.requestProgress);
    }
  }

  public async enableTwoFa(): Promise<void> {
    try {
      this.requestProgress = true;
      this.$emit("update:progress", this.requestProgress);
      await userService.enableTwoFaAsync(this.twoFaPermissionModel);
      this.showAlert(true, this.$t("users.twoFaEnabled"));
    } finally {
      this.requestProgress = false;
      this.$emit("update:progress", this.requestProgress);
    }
  }

  public async resetToken(): Promise<void> {
    try {
      this.requestProgress = true;
      this.$emit("update:progress", this.requestProgress);
      await userService.resetAuthenticationToken(this.twoFaPermissionModel.id);
      this.showAlert(true, "Token Reset Successfully");
    } finally {
      this.requestProgress = false;
      this.$emit("update:progress", this.requestProgress);
    }
  }

  public async getUserRole(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.adminPermissionFields);
      this.formlyShowSkeleton(this.twoFaPermissionFields);
      const response = await userService.getUserRolesAsync(this.userId);
      this.role = response;
      if (this.role.some((x) => x === "T-Admin")) {
        this.adminPermissionModel.tenantAdmin = true;
      }
      if (this.role.some((x) => x === "E-Admin")) {
        this.adminPermissionModel.enterpriseAdmin = true;
      }
    } finally {
      this.formlyHideSkeleton(this.adminPermissionFields);
      this.formlyHideSkeleton(this.twoFaPermissionFields);
    }
  }
  public SetPasswordToggle(): void {
    this.showPassword = !this.showPassword;
    this.setFields();
  }

  public setToggle(prop: string): void {
    const keys = Object.keys(this.userToggle);
    this.userToggle[prop] = !this.userToggle[prop];
    keys.forEach((key) => {
      if (key !== prop) {
        this.userToggle[key] = false;
      }
    });
  }
public async GetAllMobileRoles() {
  try{
    this.Mobileroles= await userService.GetAllMobileRoles();
  }
  finally{

  }
}
  public async GetUserDetailsByUserId(): Promise<void> {
    try {
      this.loading = true;
      this.storeLoading = true;
      this.formlyShowSkeleton(this.adminPermissionFields);
      const response = await userService.GetUserDetailsByUserId(this.userId);
    if (Array.isArray(response.mobileRoles) && response.mobileRoles.length > 0) {
  this.selectedMobileRoles = [...response.mobileRoles];
  this.currentMobileRoles = [...response.mobileRoles];
} else {
  this.selectedMobileRoles = [];
}

      this.workDayModel.employeeId = response.employeeId;
      this.workDayModel.positionId = response.positionId;
      this.user = response;
      this.role = response.userRoles;
      if (this.role.some((x) => x === "T-Admin")) {
        this.adminPermissionModel.tenantAdmin = true;
      }
      if (this.role.some((x) => x === "E-Admin")) {
        this.adminPermissionModel.enterpriseAdmin = true;
      }

      this.twoFaPermissionModel.isTwoFaEnabled = response.isTwoFaEnabled;
      this.workDayModel.faceId = response.faceId ? response.faceId : "";
    } finally {
      this.storeLoading = false;
      this.loading = false;
      this.formlyHideSkeleton(this.adminPermissionFields);
    }
  }

  public async getUserInfo(): Promise<void> {
    try {
      this.loading = true;
      this.storeLoading = true;
      const response = await userService.getUserByIdAsync(this.userId);
      this.user = response;
    } finally {
      this.storeLoading = false;
      this.loading = false;
    }
  }

  public deleteWarning(storeIdToDelete: number): void {
    this.storeIdToDelete = storeIdToDelete;
    this.deleteDialog.model = true;
  }
  public async deleteStore(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      await userService.removeUserStoreAsync(
        this.user.id,
        this.storeIdToDelete
      );
      this.showAlert(true, this.$t("users.alertUserStoreDeleted"));
      this.deleteDialog.model = false;
      this.getUserInfo();
    } finally {
      this.deleteDialog.loading = false;
    }
  }

  public async submitWorkDayDetail() {
    if (this.attachmentFiles.length > 0) {
      try {
        this.btnloading = true;
        await userService.userWorkDayDetails(
          this.userId,
          this.workDayModel.employeeId,
          this.workDayModel.positionId,
          this.attachmentFiles
        );
        this.showAlert(true, "User Configured Successfully.");
        this.selectedFiles = "";
        this.attachmentFiles = [];
        this.files = [];
      } finally {
        this.workDayModel.employeeId = "";
        this.workDayModel.positionId = "";
        this.attachmentFiles = [];
        this.selectedFiles = "";
        this.files = [];
        this.btnloading = false;
        this.GetUserDetailsByUserId();
        this.getUserProfileImageInfo();
        this.$root.$emit('resetFileList', this.fileUploderRef);
      }
    }else {
      this.showAlert(false, this.$t('vehicleReviveAttachment.alertSelectFileForUpload'));
    }
  }

  public getUserImageHeaders: VHeaders[] = [
    {
      text: "Image Id",
      align: "left",
      value: "id",
      sortable: false,
    },
    {
      text: "Image",
      align: "center",
      value: "uri",
      sortable: false,
      fieldType: "template",
      template: (item) => {
        return `<div class="v-avatar" style="height: 60px;min-width: 60px;width: 60px;"><img src="${item.uri}"/></div>`;
      },
    },
    {
      text: this.$parent.$t("myExpense.attachmentHeader.action") as string,
      align: "center",
      sortable: false,
      isNotDataProp: true,
    },
  ];

  public async getUserProfileImageInfo(): Promise<void> {
    try {
      this.userImageLoading = true;
      const response = await userService.getUserProfileImages(this.userId);
      this.userImagesList = response;
    } finally {
      this.userImageLoading = false;
    }
  }

  public userImageActions: VAction[] = [
    {
      type: "button",
      icon: "fas fa-eye",
      title: "View Full Image",
      color: "primary",
      loading: false,
      visible: (model: any) => true,
      action: (model: any) => {
        this.viewFullImage(model);
      },
    },
  ];

  public viewFullImage(model: any) {
    this.userFullImageUri = model.uri;
    this.showUserImageDetails.model = true;
  }

  public fileUploadLoader(val: boolean) {
    this.btnloading = val;
  }
}
